import { observer } from 'mobx-react-lite';
import { createContext, type ReactNode, useEffect } from 'react';
import { ALL_VARIANTS } from '@/constants/variants';
import { useStores } from 'src/components/common/root-store-provider/root-store-provider';
export type ThemeContextType = {
  variant: string;
};
export const ThemeContext = createContext<ThemeContextType>({
  variant: 'variant21'
});
export const ThemeProvider = observer(({
  children
}: {
  children: ReactNode;
}) => {
  const {
    authStore
  } = useStores();
  const {
    variant
  } = authStore;
  useEffect(() => {
    if (ALL_VARIANTS.some(({
      variant_name
    }) => variant_name === variant)) {
      document.body.dataset.theme = variant;
    } else {
      document.body.dataset.theme = 'default';
    }
  }, [variant]);
  return <ThemeContext.Provider value={{
    variant
  }}>
        {children}
      </ThemeContext.Provider>;
});